module.exports = __webpack_public_path__ + "static/moonlitNightClassicalSnippet1Arranged-835e43ed7aa12d47182b8e6352d76489.mp3";